<template>
  <div class="page-fixed">
    <dl>
      <dt></dt>
      <dd>
        <h3>{{ $t('验证不通过') }}</h3>
        <p>
          {{
            $t(
              '您的信息审核结果更新可能存在延时，请于收到终审通过通知的1个工作日后再试！'
            )
          }}
        </p>
      </dd>
    </dl>
    <h6>
      {{ $t('请登录') }}
      <a :href="mediaLink" target="_blank" @click.prevent="mediaRegister">{{
        $t('记者注册系统')
      }}</a
      >{{ $t('，查看审核状态') }}<span></span>
    </h6>
    <router-link to="/mobile/news" class="btn">{{
      $t('以普通用户身份继续访问')
    }}</router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mediaLink: process.env.VUE_APP_MEDIA
    }
  },
  methods: {
    mediaRegister() {
      window.location.href = 'https://media.ciftis.org'
      // Dialog.alert({
      //   message: this.$t('媒体记者注册已关闭'),
      //   confirmButtonText: this.$t('确定')
      // }).then(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.page-fixed {
  font-size: 0.28rem;
  color: #666;
  text-align: center;
  dl {
    dt {
      width: 1.28rem;
      height: 1.28rem;
      margin: 2rem auto 0.4rem;
      background: url('~@/assets/img-m/news/icon-error.png') no-repeat;
      background-size: 100% 100%;
    }
    dd {
      > h3 {
        font-size: 0.32rem;
        color: #212121;
      }
      > p {
        padding: 0.3rem 0.6rem;
        line-height: 0.42rem;
      }
    }
  }
  h6 {
    a {
      color: $themeColor;
      text-decoration: underline $themeColor;
    }
  }
  .btn {
    width: 6.3rem;
    height: 0.8rem;
    line-height: 0.8rem;
    position: absolute;
    bottom: 1rem;
    left: 50%;
    margin-left: -3.15rem;
    text-align: center;
    color: #fff;
    font-size: 0.32rem;
    border-radius: 0.4rem;
    @include linearBg();
  }
}
</style>
